import { bindingQuality } from './bindingQuality.js';

export const EXPORT_PREVIEW_DEFAULT_PAGE_SIZE = 100;
export const ALL = 'all';

export const titleCase = (value) => String(value || '')
  .replace(/_/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/\b\w/g, (letter) => letter.toUpperCase())
  .replace(/\bGm\b/g, 'GM')
  .replace(/\bCpq\b/g, 'CPQ')
  .replace(/\bSf\b/g, 'SF');

export const productLabel = (row) => (
  row.replacementProductCode
    ? `${row.productCode || '--'} -> ${row.replacementProductCode}`
    : row.productCode || '--'
);

export const bindingIsExact = (row) => {
  const label = String(row.accountConfidenceLabel || row.bindingConfidenceLabel || '').toLowerCase();
  const method = String(row.accountMatchMethod || row.bindingMethod || '').toLowerCase();
  const confidence = Number(row.accountConfidence ?? row.bindingConfidence ?? row.matchConfidence);
  return label === 'exact' || method.includes('exact') || confidence >= 95;
};

export const bindingHoverLabel = (row) => {
  const quality = bindingQuality(row);
  if (quality.missingEvidenceLink && quality.missingSalesforceAccount) return 'Missing evidence and Salesforce account';
  if (quality.missingEvidenceLink) return 'Missing evidence';
  if (quality.missingSalesforceAccount) return 'Missing Salesforce account';
  return titleCase(row.accountConfidenceLabel || row.bindingConfidenceLabel || (bindingIsExact(row) ? 'exact' : 'not exact'));
};

export const bindingTextSx = (row) => {
  const quality = bindingQuality(row);
  if (quality.missingEvidenceLink || quality.missingSalesforceAccount) {
    return { color: 'error.main', fontWeight: 900 };
  }
  return {
    color: bindingIsExact(row) ? 'success.main' : 'warning.main',
    fontWeight: 900,
  };
};

export const isExportedAction = (row) => {
  const status = String(row.status || row.saveStatus || '').toLowerCase();
  const lifecycle = String(row.exportLifecycleStatus || '').toLowerCase();
  return status === 'exported' || ['exported', 're_exported'].includes(lifecycle);
};

export const laneCanExport = (hasRows, laneReadiness = {}) => {
  const status = String(laneReadiness.status || '').toLowerCase();
  return Boolean(hasRows) && !['blocked', 'warning'].includes(status);
};
